import React from 'react'
import Breadcrumb_comp from '../Common-Component/Breadcrumb_comp/Breadcrumb_comp'
import JobInfoComponent from './JobInfoComponent/JobInfoComponent'
import ApplicationForm from './ApplicationForm/ApplicationForm'
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getCareerById } from '../../features/career/careerSlice';
const JobApplicationForm = () => {

    const { id } = useParams();
    const careers = useSelector((state) => state.career.addCareerById);
    const dispatch = useDispatch();
  
    useEffect(() => {
      if (id) {
        dispatch(getCareerById(id));
      }
    }, [dispatch, id]);
  

    return (
        <section className='JobApplicationForm'>
            <div className='container'>              

                <div className='row'>
                    <div className='col-lg-6'>
                        <JobInfoComponent careers={careers} />
                    </div>
                    <div className='col-lg-6'>
                        <ApplicationForm careers={careers}/>
                    </div>
                </div>

            </div>
        </section>
    )
}

export default JobApplicationForm
